export enum FormSummaryType {
  FREE_DESIGN = "freeDesign",
  CONSULTATION = "consultation",
}
